import DataTable from "react-data-table-component";
import { customStyles } from "../../DataTableComponents/CustomStyle";
import { useThemeContext } from "../../../Context/ThemeContext";
import {
  dateTimeFieldToDate,
  getDateToday,
} from "../../../Utils/externalFunctions";

const ListRealokasi = ({ data, columns, subHeaderComponent, pending }) => {
  const { themeContext } = useThemeContext();

  const conditionalRowStyles = [
    {
      when: (row) =>
        dateTimeFieldToDate(row.waktu_pengajuan) === getDateToday("original"),
      style: (row) => ({
        backgroundColor: row.diajukan_oleh ? "pink" : "red",
      }),
    },
  ];

  return (
    <DataTable
      data={data}
      columns={columns}
      pagination
      selectableRowsHighlight
      highlightOnHover
      subHeader
      subHeaderComponent={subHeaderComponent}
      subHeaderAlign="right"
      persistTableHead
      customStyles={customStyles}
      conditionalRowStyles={conditionalRowStyles}
      progressPending={pending}
      theme={themeContext}
    />
  );
};

export default ListRealokasi;
